<template>
    <div class="active-route-task">
        <div class="top-row">
            <div class="task-icon" @click.stop.prevent="openEntityModal">
                <ParcelIcon v-if="taskData.type === 'parcel'" />
                <PassengerIcon v-if="taskData.type === 'passenger'" />
            </div>
            <div class="task-info" @click.stop.prevent="openEntityModal">
                <!--                <div v-if="taskData.type === 'parcel'" class="task-ids text-h4">-->
                <!--                    №{{ taskData.id }}({{ taskData.internal_id }})-->
                <!--                </div>-->
                <div class="info-name text-h4">
                    {{ taskData.type === 'passenger' ? taskData.name : taskData.sender.full_name }}
                </div>
                <div class="info-location text-h5 text-grey">
                    {{ taskData.from_city }} - {{ taskData.to_city }}
                </div>
            </div>
            <div class="collapse-btn" @click.stop="toggleCollapse">
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="collapse-icon"
                    :class="{ opened: !showTransactions }"
                >
                    <circle cx="15" cy="15" r="10.5" fill="#EFEFEF" />
                    <path d="M10.5 13.5L15 18" stroke="black" stroke-linecap="round" />
                    <path d="M19.5 13.5L15 18" stroke="black" stroke-linecap="round" />
                </svg>
            </div>
        </div>
        <div class="middle-row">
            <div class="payment-action">
                <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15 8.33301V21.6663M17.8571 12.2219C17.8571 10.6886 16.5781 9.44412 15 9.44412C13.4219 9.44412 12.1428 10.6886 12.1428 12.2219C12.1428 13.7552 13.4219 14.9997 15 14.9997C16.5781 14.9997 17.8571 16.2441 17.8571 17.7775C17.8571 19.3108 16.5781 20.5552 15 20.5552C13.4219 20.5552 12.1428 19.3108 12.1428 17.7775"
                        :stroke="taskData.payment?.color || '#000000'"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <circle
                        cx="15"
                        cy="15"
                        r="9.25"
                        :stroke="taskData.payment?.color || '#000000'"
                        stroke-width="1.5"
                    />
                </svg>

                <StatusComponent
                    :status-options="paymentStatusOptions"
                    :current-status="currentPaymentStatus"
                    @update-status="updatePaymentStatus"
                />
            </div>
            <div class="task-action">
                <StatusComponent
                    :status-options="taskStatusOptions"
                    :current-status="taskData.action_status"
                    @update-status="updateTaskStatus"
                />
                <img :src="actionsOptions[taskData.action_type].icon" class="action-icon" alt="" />
            </div>
        </div>

        <TransactionsList
            v-if="showTransactions"
            :entity_type="taskData.type"
            :entity_id="taskData.id"
        />
    </div>
</template>

<script>
import ParcelIcon from '@/components/icons/ParcelIcon.vue'
import PassengerIcon from '@/components/icons/PassengerIcon.vue'
import { useActiveRouteStore, useModalStore } from '@/stores/index.js'
import actionMixin from '@/mixins/actionMixin.js'
import StatusComponent from '@/components/StatusComponent.vue'
import statusesMixin from '@/mixins/statusesMixin.js'
import fetchWrapper from '@/helpers/fetch-wrapper.js'
import TransactionsList from '@/components/TransactionsList.vue'

export default {
    name: 'ActiveRouteTask',
    components: {
        TransactionsList,
        StatusComponent,
        PassengerIcon,
        ParcelIcon
    },
    mixins: [actionMixin, statusesMixin],
    props: {
        taskData: {
            type: Object,
            required: true
        }
    },
    setup() {
        const modalStore = useModalStore()
        const activeRouteStore = useActiveRouteStore()

        return { modalStore, activeRouteStore }
    },
    data() {
        return {
            showTransactions: false
        }
    },
    computed: {
        currentPaymentStatus() {
            return this.paymentStatusOptions.filter((status) => {
                return status.value === this.taskData.payment?.value
            })[0]
        }
    },
    methods: {
        toggleCollapse() {
            this.showTransactions = !this.showTransactions
        },

        updatePaymentStatus(status) {
            fetchWrapper
                .patch('/route-point-entities/update-payment-status', {
                    id: this.taskData.id,
                    type: this.taskData.type,
                    status
                })
                .then((response) => {
                    this.activeRouteStore.updateEntityPaymentInRouteData(
                        this.taskData.id,
                        this.taskData.type,
                        response
                    )
                    this.$toast.success('Статус оплати змінено')
                })
        },

        updateTaskStatus(status) {
            this.activeRouteStore
                .updateTaskStatus(status, this.taskData.action_id)
                .then((response) => {
                    this.activeRouteStore.updateStatusesInRouteData(
                        this.taskData.action_id,
                        response
                    )

                    this.$toast.success('Статус завдання змінено')
                })
        },

        openEntityModal() {
            this.modalStore.entityModal.show = true
            this.modalStore.entityModal.entityType = this.taskData.type
            this.modalStore.entityModal.entityId = this.taskData.id
        }
    }
}
</script>

<style scoped lang="scss">
.active-route-task {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 1rem 0.625rem;
    margin-bottom: 0.7rem;
    cursor: pointer;
    background: $grey-light;
    border-radius: 0.625rem;

    &:last-of-type {
        margin-bottom: 0;
    }

    .top-row {
        display: flex;
        align-items: center;
        margin-bottom: 0.625rem;

        .task-info {
            margin-right: 1.25rem;

            .task-ids {
                margin-bottom: 0.25rem;
            }
        }

        .collapse-btn {
            margin-left: auto;
        }

        .collapse-icon {
            transition: all ease-in-out 0.3s;

            circle {
                fill: $yellow;
            }

            path {
                stroke: $white;
            }

            &.opened {
                transform: rotate(-180deg);
            }
        }

        .task-icon {
            margin-right: 0.5rem;
        }
    }

    .middle-row {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .payment-action,
        .task-action {
            display: flex;
            align-items: center;

            .status-component {
                margin: 0 0.5rem;
            }
        }
    }

    .transactions-list {
        margin-top: 1rem;
        border-top: 1px solid $white;
        padding-bottom: 0;

        :deep(.list-header) {
            margin-bottom: 0.75rem;
            border-color: $white;
        }
    }
}
</style>
